/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.1.1",
  "gitBuildTime": "2026-03-23T14:52:08.403Z",
  "gitBuildVersion": "2.1.1",
  "gitCommitId": "aab0608",
  "gitCommitIdFull": "aab06084ccbd8fc70733f629cb7e25df0118db28",
  "gitCommitTime": "2026-03-23T14:50:22.000Z",
  "version": "2.1.1-2026-03-23T14:50:22.000Z-(aab0608)"
};
